export interface LookUp {
    id: string;
    name: string;
}

export enum UserRegistrationStatus
{
    NotRegistered = 0,
    Registered = 10
}

export const userRegistrationStatusText = {
    [UserRegistrationStatus.Registered]: "Registered",
    [UserRegistrationStatus.NotRegistered]: "Not Registered",
};
